const GENERIC_PAYMENT_MESSAGE = `Infelizmente, não foi possível aprovar seu pedido no momento. Você pode enviar uma nova proposta utilizando outro CPF ou tentar novamente mais tarde`;
const INSTABILITY_MESSAGE = `Ops, estamos passando por uma instabilidade no sistema de pagamentos. Tente novamente em breve`;
const GENERIC_NOT_ALLOWED_MESSAGE = `A transação não foi autorizada! É preciso que você entre em contato com o banco emissor do seu cartão`;
const GENERIC_NOT_ALLOWED_BIN_TITLE_MESSAGE = `Ops! Parece que algo deu errado :(`;
const GENERIC_NOT_ALLOWED_BIN_MESSAGE = `Por favor, confirme os dados do cartão inserido e verifique se está elegível aos termos e condições da campanha na página da oferta.`;

export {
  GENERIC_PAYMENT_MESSAGE,
  INSTABILITY_MESSAGE,
  GENERIC_NOT_ALLOWED_MESSAGE,
  GENERIC_NOT_ALLOWED_BIN_TITLE_MESSAGE,
  GENERIC_NOT_ALLOWED_BIN_MESSAGE,
};
